import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IconButton } from 'jl-design-system/components/button/Button';
import { CloseOutlined } from 'jl-design-system/components/icons/CloseOutlined';
import styles from './FlyoutMenu.scss';

export const CloseButton = ({ onClose, className }) => {
  return (
    <IconButton
      className={classNames(styles.close, className)}
      onClick={onClose}
      icon={CloseOutlined}
      background="clear"
      data-testid="nav-close-button"
      aria-label="Close"
    ></IconButton>
  );
};

CloseButton.propTypes = {
  onClose: PropTypes.func.isRequired,
};
